import React from 'react';
import { PropTypes, arrayOf, objectOf } from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

const OrderListWrap = styled.div`
  padding: 30px;
  color: gray;
  display: flex;
  justify-content: space-around;

  h3 {
    color: #ffbb0f;
  }

  p {
    color: white;
    width: 100%;
    padding-bottom: 10px;
  }

  .gas-order {
    padding: 20px;
    border: 1px solid gray;
    border-radius: 20px;
    width: 300px;
    margin: 20px;
  }
`;

const GasOrderList = ({ historyItem }) => {
  const { gasOrders, truck, trailer, billingDataTrucker } = historyItem;

  return (
    <OrderListWrap>
      {gasOrders.map(gasOrder => {
        return (
          <span className="gas-order" key={gasOrder.id}>
            <h3>Órden emitida</h3>
            <strong>Fecha de órden</strong>
            <p>{moment(gasOrder.createdAt).format('DD-MM-YYYY HH:mm a')}</p>
            <strong>Razón social estacion de servicio</strong>
            <p>{gasOrder.gasStation?.name || ''}</p>
            <strong>Razón social facturación</strong>
            <p>{billingDataTrucker?.billingData?.legalName || ''}</p>
            <strong>CUIT facturación</strong>
            <p>{billingDataTrucker?.billingData?.cuit || ''}</p>
            <strong>Patente tractor</strong>
            <p>{truck.plate}</p>
            <strong>Patente remolque</strong>
            <p>{trailer.plate}</p>
            <strong>Litros</strong>
            <p>{gasOrder.liters}</p>
          </span>
        );
      })}
    </OrderListWrap>
  );
};

GasOrderList.propTypes = {
  historyItem: objectOf(PropTypes.object),
  gasOrders: arrayOf(PropTypes.object),
};

GasOrderList.defaultProps = {
  historyItem: {},
  gasOrders: [],
};

export default GasOrderList;
